/*
 * @Description: 
 * @Author: zhaoshuai
 * @Date: 2021-03-02 10:14:32
 * @LastEditTime: 2021-03-29 15:25:55
 * @LastEditors: zhaoshuai
 */
import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [{
    path: '/',
    name: 'Home',
    redirect: '/login'
},
{
    path: '/login',
    name: 'Login',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
        import( /* webpackChunkName: "about" */ '../views/Login.vue')
},
{
    path: '/authent',
    name: 'Authent',
    component: () =>
        import('../views/Authent.vue')
},
{
    path: '/profile',
    name: 'Profile',
    component: () =>
        import('../views/Profile.vue')
},
{
    path: '/area',
    name: 'Area',
    component: () =>
        import('../views/Area.vue')
},
{
    path: '/photo',
    name: 'Photo',
    component: () =>
        import('../views/Photo.vue')
},
{
    path: '/phone',
    name: 'Phone',
    component: () =>
        import('../views/Phone.vue')
},
{
    path: '/infomation',
    name: 'Infomation',
    component: () =>
        import('../views/Infomation.vue')
},
{
    path: '/result',
    name: 'Result',
    component: () =>
        import('../views/Result.vue')
},
{
    path: '/admission',
    name: 'Admission',
    component: () =>
        import('../views/Admission.vue')
},
//补考流程
{
    path: '/secondArea',
    name: 'secondArea',
    component: () =>
        import('../views/secondArea.vue')
},
{
    path: '/secondInfomation',
    name: 'secondInfomation',
    component: () =>
        import('../views/secondInfomation.vue')
},
{
    path: '/waitPay',
    name: 'waitPay',
    component: () =>
        import('../views/waitPay.vue')
},
{
    path: '/successPay',
    name: 'successPay',
    component: () =>
        import('../views/successPay.vue')
},
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

export default router